export var EmployeeQueryKey;
(function (EmployeeQueryKey) {
    EmployeeQueryKey["Employee"] = "Employee";
    EmployeeQueryKey["UserRoles"] = "UserRoles";
    EmployeeQueryKey["TimeTable"] = "TimeTable";
    EmployeeQueryKey["OvertimeRemaining"] = "OvertimeRemaining";
    EmployeeQueryKey["OvertimeCorrections"] = "OvertimeCorrections";
})(EmployeeQueryKey || (EmployeeQueryKey = {}));
